import React, { FC } from 'react'
import Image from 'next/image'
import { CountryWithIcon } from '@entities/country'
import { useCyberStore } from '@entities/tsp'
import { useTheme } from '@shared/lib/theme'
import { ICON_TCP } from '@shared/config'
import { Select, SelectOption } from '@shared/ui/organisms'
import WorldIcon from '@shared/assets/icons/WorldIcon'

interface SteamVoucherCountrySelectProps {
  countryVouchers: CountryWithIcon[]
}

const SteamVoucherCountrySelect: FC<SteamVoucherCountrySelectProps> = ({ countryVouchers }) => {
  const { theme } = useTheme()

  const { activeCountry, setActiveCountry } = useCyberStore()

  const options = countryVouchers?.map(({ country, icon }) => ({
    value: country,
    label: country,
    icon: <Image src={`${ICON_TCP}${icon}`} alt="icon" height={52} width={52} />,
  }))

  const handleCountryChange = (option: SelectOption) => {
    setActiveCountry(option.value)
  }

  const selectedOption = options.find((option) => option.value === activeCountry) || null

  return (
    <Select
      value={selectedOption}
      placeholder="Выберите регион"
      placeholderIcon={<WorldIcon color={theme.colors.icon.secondary} />}
      onSelect={handleCountryChange}
      options={options}
    />
  )
}

export default SteamVoucherCountrySelect
